(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/product-start-page/views/promos/default-promos.js') >= 0) return;  svs.modules.push('/components/app/product-start-page/views/promos/default-promos.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.app=_svs.app||{};
_svs.app.product_start_page=_svs.app.product_start_page||{};
_svs.app.product_start_page.templates=_svs.app.product_start_page.templates||{};
svs.app.product_start_page.templates.default_promos = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "";
},"useData":true});
Handlebars.partials['components-app-product_start_page-default_promos'] = svs.app.product_start_page.templates.default_promos;
})(svs, Handlebars);

 })(window);